import { render } from "./indexnewBindAlipay.vue?vue&type=template&id=0e893692&scoped=true&ts=true"
import script from "./indexnewBindAlipay.vue?vue&type=script&lang=ts"
export * from "./indexnewBindAlipay.vue?vue&type=script&lang=ts"

import "./indexnewBindAlipay.vue?vue&type=style&index=0&id=0e893692&scoped=true&lang=scss"

import exportComponent from "D:\\project\\H5-NEW\\H5\\APP内嵌H5\\rs-h5app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e893692"]])

export default __exports__